export default __webpack_public_path__ + "static/media/LittleWallet.cc7923c6.png";